// NAV
const overlayer = document.querySelector('.menu-overlayer');
const overlayerWrapper = overlayer.querySelector('.site-wrapper');
const overlayerContent = overlayer.querySelector('.overlayer-content');
const panels = document.querySelectorAll('.nav-panel');
const navButtons = document.querySelectorAll('.nav-button');
const closebuttons = document.querySelectorAll('.panel-close');

// Remove active class on page load
overlayer.classList.remove('active');
console.log('ARUBA');

// Check if viewport is mobile
const isMobile = () => window.innerWidth < 768;

// Handle back/forward navigation (when page is restored from cache)
window.addEventListener('pageshow', (event) => {
	if (event.persisted) {
		// Page was restored from bfcache, close the menu
		closePanels();
	}
});

// Close Panels
const closePanels = () => {
	panels.forEach(panel => {
		panel.classList.remove('active');
	});
	overlayer.classList.remove('active');

	// Clear overlayer content on mobile
	if (isMobile()) {
		overlayerContent.innerHTML = '';
	}
};


// Handle Nav Buttons
navButtons.forEach((button) => {
	button.addEventListener('click', () => {

		closePanels();

		const panelId = button.getAttribute('aria-controls');
		const panel = document.getElementById(panelId);
		const parent = button.closest('.grid-item');

		const color = getComputedStyle(parent)
			.getPropertyValue('--item-cor-fundo')
			.trim();
		overlayerWrapper.style.setProperty('--item-cor-fundo', color);

		const textColor = getComputedStyle(parent)
			.getPropertyValue('--item-cor-texto')
			.trim();
		overlayerWrapper.style.setProperty('--item-cor-texto', textColor);

		if (isMobile()) {
			// On mobile: copy panel content to overlayer
			if (panel) {
				overlayerContent.innerHTML = panel.innerHTML;
				overlayer.classList.add('active');

				// Check if parent is one of the first 3 children
				const parentIndex = Array.from(parent.parentElement.children).indexOf(parent);
				if (parentIndex >= 0 && parentIndex < 3) {
					overlayer.classList.add('first-row');
				} else {
					overlayer.classList.remove('first-row');
				}
			}
		} else {
			// On desktop: show panel normally
			if (panel) {
				panel.classList.add('active');
			}
			overlayer.classList.add('active');
		}

	});
});

// Handle Close buttons
closebuttons.forEach((close) => {
	close.addEventListener('click', () => {
		closePanels();
	});
});

// Also handle close buttons that are dynamically added to overlayer on mobile
overlayer.addEventListener('click', (e) => {
	if (e.target.closest('.panel-close')) {
		closePanels();
	}
});
